import types from '@/constants/types.js'

import router from '@/router/index.js'
import socket from '@/tools/socket.js'
import broadcast from '@/tools/broadcast.js'
import states from '@/constants/state.js'


import {
    Notification
} from 'element-ui'; // 配置请求的默认值 iframe用?

const state = states.studentsState;

const getters = {
    loginData(state, getters, rootState) {
        return state.loginData;
    },
    examGroupId(state, getters, rootState) {
        return state.examGroupId;
    },
    positionId(state, getters, rootState) {
        return state.positionId;
    },
    bigDataAnalystSubmit(state, getters, rootState) {
        return state.bigDataAnalystSubmit
    }
}

const mutations = {
    [types.STUDENTS_LOGINOUT](state, value) {
        state.loginData = {};
        sessionStorage.removeItem('state');
        sessionStorage.removeItem('AccessToken');
        let path = sessionStorage.getItem("logout-router") || '/LoginIndex';
        router.push({
            path,
            query: {
                redirect: path
            }
        });
        broadcast.emit('loginBtnClick')
        // if (router.currentRoute.path.indexOf('/login') == -1) {
        //   router.replace({
        //     path: localStorage.getItem('loginPath'),
        //     query: {
        //       redirect: router.currentRoute.path
        //     },
        //   }, function () {
        //     broadcast.emit('loginBtnClick')
        //   })
        // } else {
        //   broadcast.emit('loginBtnClick')
        // }
    },
    [types.STUDENTS_LOGININ](state, value) {
        state.loginData = value;
        let obj = {
            race: '',
            role: '',
            Name: ''
        };

        if (states.rootState.routermess) {
            obj = JSON.parse(states.rootState.routermess);
        }
        if (value && value.Type)
            switch (value.Type) {
                case 1: //学生
                case 7: //普通用户
                    obj.role = 'students';
                    break;
                case 2://老师
                    obj.role = 'teachers';
                    break;
                case 3: //教务
                    obj.role = 'dean';
                    break;
            }
        states.rootState.routermess = JSON.stringify(obj);
        if (location.hash.length < 16) {
            Notification({
                title: "提示",
                message: `登录成功！`,
                type: "success"
            });
        }
        if (value && value.AccessToken)
            sessionStorage.setItem('AccessToken', value.AccessToken);
    },
    // 消息推送的服务器地址
    [types.STUDENTS_SERVERURL](state, value) {
        state.serverUrl = value;
        socket.open(); //建立websocket连接
    },
    // 作答者分组群聊Id
    [types.EXAMGROUPID](state, value) {
        state.examGroupId = value;
    },
    // 作答者岗位Id
    [types.POSITIONID](state, value) {
        state.positionId = value;
    },
    // 作答者岗位Id
    [types.BIGDATAANALYST](state) {
        state.bigDataAnalystSubmit = true;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/students.js